var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{ref:"cascader",attrs:{"clearable":"","props":_vm.props},model:{value:(_vm.ids),callback:function ($$v) {_vm.ids=$$v},expression:"ids"}})}
var staticRenderFns = []

export { render, staticRenderFns }